import React from 'react';
import { formatDate } from '@perch-labs/warbler';
import { Button, Text } from '@perch-labs/shrike';
import { Row, RowChild } from 'styles';
import { copyFor } from 'config';
import { MappedContractSubscriberRequirement } from 'hooks/use-contract-requirements.hook';
import { ActionButton } from './contracts.style';

const getCopy = copyFor('settings.contractAgreements');

interface Props {
  id: number;
  contractVersionId?: number;
  createdAt?: string;
  details?: string;
  displayName: string;
  disclosureContract?: MappedContractSubscriberRequirement;
  handleDisplayDisclosureModal?: () => void;
  fileUrl?: string;
}

export const Contract = ({
  id,
  contractVersionId,
  createdAt,
  details,
  displayName,
  disclosureContract,
  handleDisplayDisclosureModal,
  fileUrl,
}: Props) => {
  return (
    <Row
      key={id}
      flex
      alignItems="center"
      hideTopBorder={true}
      hasBottomBorder={true}
    >
      <RowChild>
        <div>
          <Text tag="h2" textStyle="heading500">
            {displayName}
          </Text>
          {details && <Text margin={{ top: '8px' }}>{details}</Text>}
          {createdAt && (
            <Text margin={{ top: '8px' }}>
              {getCopy('signedOn', {
                acceptedDate: formatDate(createdAt),
              })}
            </Text>
          )}
        </div>
        {disclosureContract?.signatureType === 'docuSign' &&
        disclosureContract?.contractVersionId === contractVersionId ? (
          <Button
            onClick={handleDisplayDisclosureModal}
            size="small"
            backgroundless
          >
            Resend form
          </Button>
        ) : null}
        {fileUrl ? (
          <ActionButton
            aria-label={getCopy('download', {
              agreementName: displayName,
            })}
            icon="UIDownload"
            onClick={() => window.open(fileUrl, '_newtab')}
          />
        ) : null}
      </RowChild>
    </Row>
  );
};
